export default __webpack_public_path__ + "static/media/skeleton_standing.c0db8b41.svg";